import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AttendanceReport } from './Pages/listing';

export const AttendanceReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={AttendanceReport} />
    </Fragment>
)